import ReactDOM from "react-dom/client";
import { ReactLocation, Router, Outlet } from "react-location";

import Layout from "./Layout";
import PageAbout from "./PageAbout";
import PageHome from "./PageHome";
import PageProjectIndigoNeo from "./PageProjectIndigoNeo"
import PageProjectORevoir from "./PageProjectORevoir"
import PageProjectVisualIdentity from "./PageProjectVisualIdentity"
import PageProjectBlissimGift from "./PageProjectBlissimGift"
import PageProjectBlissimRGPD from "./PageProjectBlissimRGPD"

import './index.scss';

const ROUTES = [{
    path: "/",
    element: <PageHome />,
  }, {
    path: "/a-propos",
    element: <PageAbout />,
  }, {
    path: "/projet/indigo-neo",
    element: <PageProjectIndigoNeo />,
  }, {
    path: "/projet/identite-visuelle",
    element: <PageProjectVisualIdentity />,
  }, {
    path: "/projet/o-revoir",
    element: <PageProjectORevoir />,
  }, {
    path: "/projet/blissim-gift",
    element: <PageProjectBlissimGift />,
  },{
    path: "/projet/blissim-rgpd",
    element: <PageProjectBlissimRGPD />,
  },

];
const LOCATION = new ReactLocation();

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <Router routes={ROUTES} location={LOCATION}>
    <Layout>
      <Outlet />
    </Layout>
  </Router>
);
